
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getlucky",
      function () {
        return require("private-next-pages/getlucky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getlucky"])
      });
    }
  